<template>
  <div>
    <Loader v-if="isLoading" />

    <!-- Left Sidebar Menu (Hando style) -->
    <aside class="sidebar-wrapper" :class="{ open: isSidebarOpen }">
      <div
        class="sidebar-brand d-flex align-items-center justify-content-start position-relative"
      >
        <div
          class="brand-logo-container"
          @click="gotolanding"
          style="cursor: pointer"
        >
          <img
            src="@/assets/images/cts_logo_hzl-wo_bg.png"
            alt="Cerise Tech Solutions"
            class="brand-logo-img"
          />
        </div>
        <button
          class="sidebar-close-btn d-lg-none position-absolute"
          @click="$emit('close-sidebar')"
          style="right: 15px"
        >
          <i class="bi bi-x-lg"></i>
        </button>
      </div>

      <nav class="sidebar-nav">
        <div class="nav-section">
          <!-- <div class="nav-section-title">MENU</div> -->

          <!-- Dashboard link -->
          <div class="nav-item-wrapper">
            <a
              href="#"
              @click.prevent="gotolanding"
              class="nav-item-link"
              :class="{ active: $route.path.includes('dashboard') }"
            >
              <i class="bi bi-house-door"></i>
              <span class="nav-item-text">Dashboard</span>
            </a>
          </div>

          <!-- Dynamic menus list. A row whose Menu URL is the "cerisedocket" sentinel (see
               isCeriseDocketMenu) is the CTSDMS SSO handoff instead of a normal internal
               route - add it from HRMS's own Menu Master like any other menu item, with
               Menu URL set to exactly "cerisedocket" (case-insensitive). -->
          <div
            v-for="menu in menus"
            :key="menu.menu_name"
            class="nav-item-wrapper"
            :class="{
              'has-submenu': menu.subs.length,
              open: expandedMenuId === menu.menu_name,
            }"
          >
            <a
              v-if="!menu.subs.length"
              href="#"
              @click.prevent="handleMenuClick(menu)"
              class="nav-item-link"
              :class="{ active: isRouteMatch($route.path, menu.menu_url) }"
            >
              <i :class="getMenuIcon(menu.menu_name)"></i>
              <span class="nav-item-text">{{ menu.menu_name }}</span>
            </a>
            <div v-else class="nav-item-link-container">
              <a
                href="#"
                class="nav-item-link dropdown-toggle-custom"
                :class="{ active: isParentActive(menu) }"
                @click.prevent="toggleSubmenu(menu.menu_name)"
              >
                <i :class="getMenuIcon(menu.menu_name)"></i>
                <span class="nav-item-text">{{ menu.menu_name }}</span>
                <i class="bi bi-chevron-down submenu-arrow"></i>
              </a>
            </div>

            <ul v-if="menu.subs.length" class="submenu-list">
              <li
                v-for="sub in menu.subs"
                :key="sub.menu_name"
                class="submenu-item"
              >
                <a
                  href="#"
                  @click.prevent="handleMenuClick(sub)"
                  class="submenu-link"
                  :class="{ active: isRouteMatch($route.path, sub.menu_url) }"
                >
                  <i
                    :class="getMenuIcon(sub.menu_name)"
                    class="me-2"
                    style="
                      font-size: 0.85rem;
                      width: 1.2rem;
                      text-align: center;
                    "
                  ></i>
                  <span>{{ sub.menu_name }}</span>
                </a>
              </li>
            </ul>
          </div>
          <!-- CeriseDocket (CTSDMS) SSO handoff - always last, not part of menu_data since it's
               a fixed cross-app link rather than an HRMS menu/permission row. -->
          <div class="nav-item-wrapper">
            <a href="#" @click.prevent="goToCeriseDocket" class="nav-item-link">
              <i class="bi bi-file-earmark-text"></i>
              <span class="nav-item-text">CeriseDocket</span>
            </a>
          </div>
        </div>
      </nav>
    </aside>

    <!-- Top Header Wrapper -->
    <header
      class="content-header"
      :class="{ 'sidebar-shifted': isSidebarOpen }"
    >
      <div class="header-left">
        <button class="burger-menu-btn" @click="$emit('toggle-sidebar')">
          <i class="bi bi-list"></i>
        </button>
        <!-- <div class="page-title-greetings">
          <h1 class="greetings-title">Good Morning, {{ userdetails.fullname ? userdetails.fullname : userName }}</h1>
        </div> -->
      </div>

      <div class="header-right">
        <!-- Search Bar -->
        <!-- <div class="search-bar-wrapper d-none d-md-flex">
          <i class="bi bi-search search-icon"></i>
          <input type="text" class="search-input" placeholder="Search..." />
        </div> -->

        <div class="header-actions">
          <!-- Fullscreen Toggle -->
          <!-- <button class="action-btn-circle d-none d-sm-flex" title="Toggle Fullscreen">
            <i class="bi bi-arrows-angle-expand"></i>
          </button> -->

          <!-- Brightness Toggle -->
          <!-- <button class="action-btn-circle d-none d-sm-flex" title="Change Theme">
            <i class="bi bi-brightness-high"></i>
          </button> -->

          <!-- Notifications Bell -->
          <!-- has-unread lives on the wrapper: a reactive :class on the toggle would
               overwrite Bootstrap's "show" class and break click-outside closing -->
          <div class="notifications-bell-dropdown dropdown" :class="{ 'has-unread': unreadCount > 0 }">
            <button
              class="action-btn-circle position-relative"
              id="globalNotificationsDropdown"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i class="bi bi-bell"></i>
              <span v-if="unreadCount > 0" class="badge-dot-noti bg-danger">
                {{ unreadCount }}
              </span>
            </button>
            <div
              class="dropdown-menu dropdown-menu-end p-0 shadow-lg notification-dropdown-menu"
              aria-labelledby="globalNotificationsDropdown"
            >
              <div class="dropdown-header-custom">
                <span>Notifications</span>
                <div class="d-flex align-items-center gap-2">
                  <button v-if="unreadCount > 0" type="button" class="noti-mark-all" @click.stop="$store.dispatch('markAllNotificationsAsRead')">Mark all as read</button>
                  <span class="badge bg-purple text-white rounded-pill">{{ unreadCount }} Unread</span>
                </div>
              </div>
              <div class="dropdown-body-notifications">
                <!-- <a v-for="(notification, index) in filteredNotifications.slice(0, 5)" :key="index" @click="handleNotificationClick(notification)" class="dropdown-item-notification"> -->
                <a v-for="(notification, index) in filteredNotifications" :key="index" @click="handleNotificationClick(notification)" class="dropdown-item-notification">
                  <div class="d-flex justify-content-between align-items-center">
                    <strong class="noti-item-title">{{ notification.notification_title }}</strong>
                    <button v-if="notification.is_read === 0 || notification.is_read === '0' || !notification.is_read" type="button" class="unread-dot-btn" title="Mark as read" aria-label="Mark as read" @click.stop="$store.dispatch('markNotificationAsRead', notification.notification_id)">
                      <span class="unread-dot"></span>
                    </button>
                  </div>
                  <p class="noti-item-desc">
                    {{ notification.notification_description }}
                  </p>
                  <span class="noti-item-date"
                    >{{ notification.notification_date
                    }}<span class="noti-item-time">{{ notification.notificationTime }}</span></span
                  >
                </a>
                <div
                  v-if="!filteredNotifications.length"
                  class="no-noti-placeholder"
                >
                  No notifications
                </div>
              </div>
            </div>
          </div>

          <!-- Profile Dropdown -->
          <div class="user-profile-dropdown dropdown">
            <button
              class="profile-btn dropdown-toggle border-0 bg-transparent"
              id="globalProfileDropdown"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <img
                v-if="userdetails.employee_photo_path"
                :src="userdetails.employee_photo_path"
                class="header-profile-img"
              />
              <img
                v-else
                src="@/assets/images/profile.png"
                class="header-profile-img"
              />
              <span class="header-profile-name d-none d-md-inline-block">{{
                userdetails.fullname ? userdetails.fullname : userName
              }}</span>
              <!-- <i class="bi bi-chevron-down dropdown-arrow"></i> -->
            </button>
            <ul
              class="dropdown-menu dropdown-menu-end shadow-lg"
              aria-labelledby="globalProfileDropdown"
            >
              <li>
                <a class="dropdown-item" href="#" @click.prevent="profile"
                  ><i class="bi bi-person me-2"></i>Profile</a
                >
              </li>
              <li>
                <a class="dropdown-item" href="#" @click.prevent="resetpassword"
                  ><i class="bi bi-shield-lock me-2"></i>Reset Password</a
                >
              </li>
              <li><hr class="dropdown-divider" /></li>
              <li>
                <a
                  class="dropdown-item text-danger"
                  href="#"
                  @click.prevent="logout"
                  ><i class="bi bi-box-arrow-right me-2"></i>Logout</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </header>

    <!-- Global Sticky Footer -->
    <footer
      class="content-footer"
      :class="{ 'sidebar-shifted': isSidebarOpen }"
    >
      <span class="footer-text"
        >© 2026 CeriseTech Solutions Pvt. Ltd. All rights reserved.</span
      >
    </footer>

    <!-- Reset Password Modal -->
    <div
      class="modal fade"
      id="resetModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      data-bs-backdrop="static"
      data-bs-keyboard="false"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content border-0 shadow-lg">
          <div class="modal-header bg-light border-0 py-3">
            <h1 class="modal-title fs-5 fw-bold" id="exampleModalLabel">
              Reset Password
            </h1>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body p-4">
            <form @submit.prevent="reset_pass_save()">
              <div class="form-group mb-3">
                <label for="recipient-name" class="form-label fw-bold"
                  >Username</label
                >
                <input
                  type="text"
                  v-model="userdetails.user_name"
                  class="form-control bg-light"
                  id="recipient-name"
                  placeholder="Username"
                  disabled
                />
              </div>

              <div class="form-group mb-3">
                <label for="current-pass" class="form-label fw-bold"
                  >Current Password</label
                >
                <div class="password-input-wrapper position-relative">
                  <input
                    :type="currentPasswordVisible ? 'text' : 'password'"
                    v-model="current_pass"
                    class="form-control pr-5"
                    id="current-pass"
                    placeholder="Enter current password"
                    maxlength="16"
                    @focus="activeField = 'current_pass'"
                    @input="stripEdgeSpacesOnInput('current_pass')"
                    @blur="handleBlur('current_pass')"
                    @keydown="handlePasswordKey($event, current_pass)"
                    @copy.prevent
                    @cut.prevent
                    @paste.prevent
                    @drop.prevent
                    required
                  />
                  <span
                    class="password-toggle-icon-custom"
                    @click="currentPasswordVisible = !currentPasswordVisible"
                  >
                    <i
                      :class="
                        currentPasswordVisible ? 'bi bi-eye-slash' : 'bi bi-eye'
                      "
                    ></i>
                  </span>
                </div>
                <small v-if="currentPassError" class="text-danger d-block mt-1">{{ currentPassError }}</small>
              </div>

              <div class="form-group mb-3">
                <label for="new-pass" class="form-label fw-bold"
                  >New Password</label
                >
                <div class="password-input-wrapper position-relative">
                  <input
                    :type="newPasswordVisible ? 'text' : 'password'"
                    v-model="new_pass"
                    class="form-control pr-5"
                    id="new-pass"
                    placeholder="Enter new password"
                    maxlength="16"
                    @focus="activeField = 'new_pass'"
                    @input="stripEdgeSpacesOnInput('new_pass')"
                    @blur="handleBlur('new_pass')"
                    @keydown="handlePasswordKey($event, new_pass)"
                    @copy.prevent
                    @cut.prevent
                    @paste.prevent
                    @drop.prevent
                    required
                  />
                  <span
                    class="password-toggle-icon-custom"
                    @click="newPasswordVisible = !newPasswordVisible"
                  >
                    <i
                      :class="
                        newPasswordVisible ? 'bi bi-eye-slash' : 'bi bi-eye'
                      "
                    ></i>
                  </span>
                </div>
                <div
                  v-if="activeField === 'new_pass' && new_pass"
                  class="password-rules-checklist-custom mt-2 p-2 bg-light rounded"
                >
                  <div
                    v-for="item in passwordRequirements"
                    :key="item.label"
                    :class="item.passed ? 'text-success' : 'text-danger'"
                    class="rule-item-custom d-flex align-items-center mb-1"
                    style="font-size: 0.75rem"
                  >
                    <i
                      :class="
                        item.passed
                          ? 'bi bi-check-circle-fill me-2'
                          : 'bi bi-circle me-2'
                      "
                    ></i>
                    <span>{{ item.label }}</span>
                  </div>
                </div>
              </div>

              <div class="form-group mb-4">
                <label for="conf-pass" class="form-label fw-bold"
                  >Confirm password</label
                >
                <div class="password-input-wrapper position-relative">
                  <input
                    :type="confirmPasswordVisible ? 'text' : 'password'"
                    v-model="conf_pass"
                    class="form-control pr-5"
                    id="conf-pass"
                    placeholder="Enter confirm password"
                    maxlength="16"
                    @focus="activeField = 'conf_pass'"
                    @input="stripEdgeSpacesOnInput('conf_pass')"
                    @blur="handleBlur('conf_pass')"
                    @keydown="handlePasswordKey($event, conf_pass)"
                    @copy.prevent
                    @cut.prevent
                    @paste.prevent
                    @drop.prevent
                    required
                  />
                  <span
                    class="password-toggle-icon-custom"
                    @click="confirmPasswordVisible = !confirmPasswordVisible"
                  >
                    <i
                      :class="
                        confirmPasswordVisible ? 'bi bi-eye-slash' : 'bi bi-eye'
                      "
                    ></i>
                  </span>
                </div>
                <small
                  v-if="
                    activeField === 'conf_pass' &&
                    conf_pass &&
                    new_pass &&
                    conf_pass === new_pass
                  "
                  class="text-success mt-1 d-block"
                >
                  <i class="bi bi-check-circle-fill me-1"></i>Password Match
                  successfully !
                </small>
              </div>

              <div class="d-flex justify-content-end gap-2 pt-2 border-top">
                <button
                  type="button"
                  class="btn btn-cancel-standard d-flex align-items-center justify-content-center"
                  style="
                    height: 35px;
                    padding: 0 20px;
                    font-size: 14px;
                    font-weight: 500;
                    border-radius: 4px;
                  "
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  class="btn btn-primary-standard d-flex align-items-center justify-content-center"
                  style="
                    height: 35px;
                    padding: 0 20px;
                    font-size: 14px;
                    font-weight: 500;
                    border-radius: 4px;
                  "
                  :disabled="!current_pass || !new_pass || !conf_pass"
                >
                  Save
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import apis from "../apis";
import Loader from "@/components/Loader.vue";
import { Modal } from "bootstrap";
import { getNotificationRoute } from "@/utils/notificationUtils";

export default {
  components: { Loader },
  name: "HrmsUiSiteNavBarLanding",
  props: {
    userName: {
      type: String,
      default: "",
    },
    isSidebarOpen: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    userdetails() {
      var nme = this.$store.getters.loggedUser;
      return nme?.data || {};
    },
    employee_id() {
      var info = this.$store.getters.loggedUser;
      return info?.data?.employee_id;
    },
    menus() {
      var nme = this.$store.getters.loggedUser;
      return nme?.data?.menu_data || [];
    },
    Dashboard_link() {
      var info = this.$store.getters.loggedUser;
      return info?.data?.Dashboard_link || "/admin_dashboard";
    },
    // Counted from the bell's own (type-filtered) list so it matches what is shown.
    unreadCount() {
      return this.filteredNotifications.filter(
        (n) => n.is_read === 0 || n.is_read === "0" || !n.is_read
      ).length;
    },
    allNotifications() {
      return this.$store.getters.allNotifications || [];
    },
    // Bell hides these notification types.
    filteredNotifications() {
      const hiddenTypes = ["Notice", "Alert", "System Alert"];
      return this.allNotifications.filter((n) => !hiddenTypes.includes(n.notification_type_name));
    },
    passwordRequirements() {
      const password = this.new_pass || "";
      return [
        { label: "Minimum 8 characters", passed: password.length >= 8 },
        { label: "Maximum 16 characters", passed: password.length <= 16 },
        { label: "One uppercase letter", passed: /[A-Z]/.test(password) },
        { label: "One lowercase letter", passed: /[a-z]/.test(password) },
        { label: "One numeric value", passed: /[0-9]/.test(password) },
        {
          label: "One special character",
          passed: /[!@#$%^&*(),.?":{}|<>]/.test(password),
        },
      ];
    },
  },
  data() {
    return {
      isLoading: false,
      new_pass: "",
      conf_pass: "",
      username: "",
      current_pass: "",
      currentPassError: "",
      errors: "",
      pollingInterval: null,
      currentPasswordVisible: false,
      newPasswordVisible: false,
      confirmPasswordVisible: false,
      expandedMenuId: null,
      activeField: "",
    };
  },
  beforeUnmount() {
    // Polling removed
    clearTimeout(this.currentPassCheckTimer);
  },
  methods: {
    // SSO handoff to Cts_dms_ui: a full top-level navigation (not $router.push - CeriseDocket
    // is a different app entirely) carrying this session's HRMS JWT in the URL FRAGMENT
    // (#hrmsToken=...), never a query string, so the token is never sent to a server or
    // recorded in access/referrer logs. Cts_dms_ui's App.vue reads it and exchanges it for a
    // CTSDMS session via HrmsSsoController - see that project for the rest of this flow.
    // goToCeriseDocket() {
    //   const token = this.$store.getters.authToken;
    //   if (!token) return;
    //   const baseUrl = process.env.VUE_APP_CERISEDOCKET_URL;
    //   window.location.href = `${baseUrl}#hrmsToken=${encodeURIComponent(
    //     token
    //   )}`;
    // },
    
      goToCeriseDocket() {
        const token = this.$store.getters.authToken;
        if (!token) return;

        const baseUrl = process.env.VUE_APP_CERISEDOCKET_URL;

        if (!baseUrl) {
          console.error("CERISEDOCKET_URL is not configured");
          return;
        }

        const url = new URL(baseUrl);
        url.hash = `hrmsToken=${encodeURIComponent(token)}`;

        window.location.href = url.toString();
      },

    // A menu_data row can't carry the fresh per-click JWT the CTSDMS handoff needs (it's
    // just a static URL from the DB), so it's recognized by this sentinel value in its Menu
    // URL field instead of being routed like a normal internal link.
    isCeriseDocketMenu(menu) {
      return (menu?.menu_url || "").trim().toLowerCase() === "cerisedocket";
    },
    handleMenuClick(menu) {
      if (this.isCeriseDocketMenu(menu)) {
        this.goToCeriseDocket();
        return;
      }
      this.closeSidebarOnMobile();
      this.$router.push(menu.menu_url);
    },
    // On mobile/tablet the sidebar overlays the page, so hide it once a page is
    // chosen. On desktop (>= 992px, same breakpoint as App.vue) it stays pinned.
    closeSidebarOnMobile() {
      if (this.isSidebarOpen && window.innerWidth < 992) {
        this.$emit("close-sidebar");
      }
    },
    stripEdgeSpacesOnInput(field) {
      if (field === "current_pass") this.currentPassError = "";
      const v = this[field];
      if (typeof v !== "string") return;
      let next = v.replace(/^\s+/, "").replace(/\s+$/, "");
      if (next.length > 0 && /[^a-zA-Z0-9]/.test(next[0])) {
        next = next.substring(1);
      }
      if (next !== v) this[field] = next;
    },
    handlePasswordKey(e, currentValue) {
      if (!e) return;
      if (e.ctrlKey || e.metaKey || e.altKey) return;
      const key = typeof e.key === "string" ? e.key : "";
      if (!key) return;
      const value = currentValue == null ? "" : String(currentValue);
      const controlKeys = [
        "Backspace",
        "Delete",
        "ArrowLeft",
        "ArrowRight",
        "ArrowUp",
        "ArrowDown",
        "Tab",
        "Shift",
        "Enter",
        "Home",
        "End",
        "CapsLock",
        "Escape",
      ];
      if (controlKeys.includes(key)) return;
      if (key.length !== 1) return;
      if (key === " ") {
        e.preventDefault();
        return;
      }
      if (value.length === 0 && /[^a-zA-Z0-9]/.test(key)) {
        e.preventDefault();
      }
    },
    handleBlur(field) {
      this.trimEdgeSpaces(field);
      if (this.activeField === field) {
        this.activeField = "";
      }
    },
    trimEdgeSpaces(field) {
      const v = this[field];
      if (typeof v === "string") {
        this[field] = v.trim();
      }
    },
    async reset_pass_save() {
      var details = {
        employee_id: this.userdetails.employee_id,
        current_password: this.current_pass,
        password: this.new_pass,
        confirm_password: this.conf_pass,
      };
      this.currentPassError = "";
      this.isLoading = true;
      let response;
      try {
        response = await apis.reset_password(details);
      } catch (err) {
        const msg =
          err?.response?.data?.message ||
          err?.response?.data?.error ||
          err?.message ||
          "Request failed";
        Swal.fire({
          icon: "error",
          title: "Error",
          width: 350,
          text: msg,
        });
        return;
      } finally {
        this.isLoading = false;
      }
      if (response.data.status === true) {
        Swal.fire({
          icon: "success",
          title: "Success",
          width: 350,
          text: response.data.message,
        });

        const modalElement = document.getElementById("resetModal");
        const modal = bootstrap.Modal.getInstance(modalElement);
        if (modal) modal.hide();
        this.logout();
      } else {
        if ((response.data.message || "").toLowerCase().includes("current password")) {
          this.currentPassError = response.data.message;
        }
        Swal.fire({
          icon: "error",
          title: "Error",
          width: 350,
          text: response.data.message,
        });
      }
    },
    resetpassword() {
      this.new_pass = "";
      this.conf_pass = "";
      this.current_pass = "";
      this.currentPassError = "";
      this.passExists = false;
      this.currentPasswordVisible = false;
      this.newPasswordVisible = false;
      this.confirmPasswordVisible = false;

      const modalElement = document.getElementById("resetModal");
      if (modalElement) {
        const modal = new bootstrap.Modal(modalElement);
        modal.show();
      }
      // No upfront password fetch anymore — current password is verified
      // server-side, on demand, as the user types (see checkCurrentPassword(),
      // debounced from the current_pass watcher below).
    },
    // Calls the authenticated /verifyCurrentPassword endpoint (always scoped
    // server-side to the logged-in user's own employee_id) to drive the live
    // "Password Match" checkmark, without ever handling the real password in
    // plaintext client-side.
    async checkCurrentPassword() {
      const checkedPass = (this.current_pass || "").trim();
      if (!checkedPass) {
        this.passExists = false;
        return;
      }
      try {
        const response = await apis.verifyCurrentPassword({
          current_password: checkedPass,
        });
        this.passExists = !!(response.data && response.data.status);
      } catch (error) {
        console.error("Error verifying current password:", error);
        this.passExists = false;
      }
    },
    profile() {
      this.$router.push({
        name: "profileview",
        params: {
          employee_id: this.employee_id,
        },
      });
    },
    gotolanding() {
      this.closeSidebarOnMobile();
      this.$router.push(this.Dashboard_link);
    },
    logout() {
      this.$store.dispatch("logout");
      this.$router.push("/");
    },
    toggleSubmenu(menuId) {
      if (!this.isSidebarOpen) {
        this.$emit("toggle-sidebar");
      }
      if (this.expandedMenuId === menuId) {
        this.expandedMenuId = null;
      } else {
        this.expandedMenuId = menuId;
      }
    },
    updateExpandedMenu() {
      if (this.menus && this.menus.length) {
        const activeParent = this.menus.find(
          (menu) =>
            menu.subs &&
            menu.subs.some((sub) =>
              this.isRouteMatch(this.$route.path, sub.menu_url)
            )
        );
        if (activeParent) {
          this.expandedMenuId = activeParent.menu_name;
        }
      }
    },
    getMenuIcon(menuName) {
      const name = (menuName || "").toLowerCase();
      if (name.includes("dashboard")) return "bi bi-house-door";
      if (name.includes("employee") || name.includes("member"))
        return "bi bi-people";
      if (name.includes("attendance")) return "bi bi-calendar2-check";
      if (name.includes("leave")) return "bi bi-calendar-x";
      if (name.includes("payroll") || name.includes("pay"))
        return "bi bi-cash-stack";
      if (name.includes("task")) return "bi bi-check2-square";
      if (name.includes("sprint")) return "bi bi-lightning";
      if (name.includes("project")) return "bi bi-folder";
      if (name.includes("holiday")) return "bi bi-gift";
      if (name.includes("reimbursement") || name.includes("claim"))
        return "bi bi-receipt";
      if (name.includes("notification")) return "bi bi-bell";
      if (name.includes("setting")) return "bi bi-gear";
      if (name.includes("department")) return "bi bi-building";
      if (name.includes("designation")) return "bi bi-briefcase";
      if (name.includes("education")) return "bi bi-mortarboard";
      if (name.includes("status")) return "bi bi-activity";
      if (name.includes("exit")) return "bi bi-box-arrow-right";
      if (name.includes("location")) return "bi bi-geo-alt";
      if (name.includes("menu")) return "bi bi-list-nested";
      if (name.includes("master")) return "bi bi-sliders";
      if (name.includes("account")) return "bi bi-person-gear";
      if (name.includes("docket")) return "bi bi-file-earmark-text";
      return "bi bi-circle";
    },
    isRouteMatch(routePath, menuUrl) {
      if (!routePath || !menuUrl) return false;
      const normalize = (str) => str.toLowerCase().replace(/[-_/#]/g, "");
      return normalize(routePath) === normalize(menuUrl);
    },
    isParentActive(menu) {
      if (!menu.subs || !menu.subs.length) {
        return this.isRouteMatch(this.$route.path, menu.menu_url);
      }
      return menu.subs.some((sub) =>
        this.isRouteMatch(this.$route.path, sub.menu_url)
      );
    },
    async handleNotificationClick(notification) {
      if (
        notification.is_read === 0 ||
        notification.is_read === "0" ||
        !notification.is_read
      ) {
        this.$store.dispatch(
          "markNotificationAsRead",
          notification.notification_id
        );
      }

      const targetRoute = await getNotificationRoute(notification);
      this.$router.push(targetRoute);
    },
  },
  watch: {
    // Right after login the navbar mounts before /getUserDetails has supplied
    // employee_id (the JWT doesn't carry it), so fetch once it's available
    // instead of only on mount. Also refetches if a different user logs in.
    employee_id: {
      immediate: true,
      handler(id) {
        if (id) this.$store.dispatch("fetchNotifications");
      },
    },
    current_pass() {
      // Debounced so we're not calling the API on every keystroke.
      clearTimeout(this.currentPassCheckTimer);
      this.currentPassCheckTimer = setTimeout(() => {
        this.checkCurrentPassword();
      }, 400);
    },
    "$route.path": {
      immediate: true,
      handler(newPath, oldPath) {
        this.updateExpandedMenu();
        // Covers navigation from outside the sidebar too (browser back, notifications).
        this.closeSidebarOnMobile();
        // Refresh notifications on every page change. Skipped on the first
        // (immediate) run: the employee_id watcher already loads them then.
        if (oldPath !== undefined && this.employee_id) {
          this.$store.dispatch("fetchNotifications");
        }
      },
    },
    menus: {
      immediate: true,
      handler() {
        this.updateExpandedMenu();
      },
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&display=swap");

/* Sidebar Wrapper styles */
.sidebar-wrapper {
  width: 260px;
  background-color: var(--sidebar-bg);
  border-right: 1px solid var(--sidebar-border);
  display: flex;
  flex-direction: column;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1050;
  transition: width 0.3s ease, transform 0.3s ease;
  transform: translateX(-260px);
  font-family: "Plus Jakarta Sans", sans-serif;
  overflow: hidden;
}

.sidebar-wrapper.open {
  transform: translateX(0);
}

@media (min-width: 992px) {
  .sidebar-wrapper {
    transform: translateX(0);
    width: 66px;
    overflow: hidden;
  }

  .sidebar-wrapper.open {
    width: 260px;
  }
}

.sidebar-brand {
  /* height: 74px; */
  display: flex !important;
  align-items: center !important;
  justify-content: flex-start !important;
  padding: 0 !important;
  border-bottom: 1px solid var(--sidebar-border);
  background-color: var(--sidebar-bg);
  transition: all 0.3s ease;
  overflow: hidden;
  width: 260px !important;
  flex-shrink: 0 !important;
}

.brand-logo-container {
  display: flex !important;
  align-items: center !important;
  justify-content: flex-start !important;
  width: 260px !important;
  padding-left: 0.3rem !important;
  transition: all 0.3s ease;
  flex-shrink: 0 !important;
}

.brand-logo-container img {
  max-height: 58px !important;
  width: auto !important;
  max-width: none !important;
  object-fit: contain;
  margin: 0 !important;
  display: block !important;
  transition: all 0.3s ease;
  flex-shrink: 0 !important;
}

.sidebar-close-btn {
  background: none;
  border: none;
  font-size: 1.25rem;
  color: #64748b;
  cursor: pointer;
}

.sidebar-nav {
  flex-grow: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 24px 16px;
  width: 260px !important;
}

.nav-section {
  margin-bottom: 24px;
}

.nav-section-title {
  font-size: 11px;
  font-weight: 700;
  color: #94a3b8;
  letter-spacing: 0.1em;
  padding: 0 12px 12px 12px;
  text-transform: uppercase;
  transition: display 0.3s ease;
}

.nav-item-wrapper {
  margin-bottom: 4px;
}

.nav-item-link {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  color: #475569 !important;
  font-size: 14px;
  font-weight: 700;
  border-radius: 8px;
  text-decoration: none;
  transition: all 0.25s ease;
  cursor: pointer;
}

.nav-item-link i {
  font-size: 1.15rem;
  margin-right: 12px;
  width: 20px;
  text-align: center;
  color: var(--sidebar-inactive-color) !important;
  transition: all 0.25s ease;
  font-weight: 700 !important;
  -webkit-text-stroke: 0.5px currentColor;
}

.nav-item-link:hover {
  background-color: var(--sidebar-hover-bg) !important;
  color: #0f172a !important;
}

.nav-item-link:hover i {
  color: #0f172a !important;
}

/* Primary/Brand color highlights */
.nav-item-link.active {
  background-color: var(--active-menu-bg) !important;
  color: var(--sidebar-active-color) !important;
  font-weight: 700 !important;
  box-shadow: none !important;
  border-left: 5px solid var(--primary-color) !important;
  border-top-left-radius: 6px !important;
  border-bottom-left-radius: 6px !important;
  border-top-right-radius: 8px !important;
  border-bottom-right-radius: 8px !important;
  padding-left: 8px !important;
}

.nav-item-link.active i {
  color: var(--sidebar-active-color) !important;
  font-weight: 700 !important;
}

.dropdown-toggle-custom {
  justify-content: space-between;
  width: 100%;
}

.submenu-arrow {
  margin-left: auto;
  font-size: 0.8rem !important;
  color: #64748b !important;
  transition: transform 0.2s ease;
}

.nav-item-link.active .submenu-arrow {
  color: var(--primary-color) !important;
}

.nav-item-wrapper.open .submenu-arrow {
  transform: rotate(180deg);
}

.submenu-list {
  list-style: none;
  padding-left: 20px;
  margin-top: 4px;
  margin-bottom: 8px;
  display: none;
}

.nav-item-wrapper.open .submenu-list {
  display: block;
}

.submenu-item {
  margin-bottom: 4px;
}

.submenu-link {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  color: #475569 !important;
  font-size: 13.5px;
  font-weight: 500;
  text-decoration: none;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.submenu-link i {
  color: var(--sidebar-inactive-color) !important;
  -webkit-text-stroke: 0.5px currentColor;
}

.submenu-link:hover {
  color: #0f172a !important;
  background-color: var(--sidebar-hover-bg) !important;
}

.submenu-link:hover i {
  color: #0f172a !important;
}

.submenu-link.active {
  color: var(--sidebar-active-color) !important;
  background-color: var(--active-menu-bg) !important;
  font-weight: 600 !important;
  box-shadow: none !important;
}

.submenu-link.active i {
  color: var(--sidebar-active-color) !important;
}

@media (min-width: 992px) {
  /* Collapsed sidebar visibility transitions */
  .sidebar-wrapper:not(.open) .nav-item-text,
  .sidebar-wrapper:not(.open) .nav-section-title,
  .sidebar-wrapper:not(.open) .submenu-arrow,
  .sidebar-wrapper:not(.open) .submenu-list,
  .sidebar-wrapper:not(.open) .sidebar-footer,
  .sidebar-wrapper:not(.open) .sidebar-close-btn {
    display: none !important;
  }
}

/* Content Header styles */
.content-header {
  /* height: 62px; */
  background-color: #ffffff;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 15px;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1050;
  transition: left 0.3s ease;
  font-family: "Plus Jakarta Sans", sans-serif;
}

.header-left {
  display: flex;
  align-items: center;
}

.burger-menu-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #334155;
  cursor: pointer;
}

.greetings-title {
  font-size: 19px;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
  letter-spacing: -0.3px;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 24px;
}

.search-bar-wrapper {
  background-color: #f1f5f9;
  border-radius: 8px;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  width: 240px;
}

.search-icon {
  color: #64748b;
  margin-right: 10px;
}

.search-input {
  background: none;
  border: none;
  outline: none;
  font-size: 13px;
  color: #334155;
  width: 100%;
}

.search-input::placeholder {
  color: #94a3b8;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.action-btn-circle {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background-color: #f8fafc;
  border: 1px solid #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #64748b;
  cursor: pointer;
  transition: all 0.2s ease;
}

.action-btn-circle:hover {
  background-color: #f1f5f9;
  color: #0f172a;
}

.badge-dot-noti {
  position: absolute;
  top: -2px;
  right: -2px;
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: 8px;
  font-size: 9px;
  font-weight: 700;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Animated bell when there are unread notifications */
.has-unread .action-btn-circle {
  color: var(--primary-color);
  animation: bell-glow 2s ease-in-out infinite;
}

.has-unread .action-btn-circle .bi-bell {
  display: inline-block;
  transform-origin: top center;
  animation: bell-ring 2.5s ease-in-out infinite;
}

.has-unread .action-btn-circle .badge-dot-noti {
  animation: badge-pulse 2s ease-in-out infinite;
}

@keyframes bell-ring {
  0%, 50%, 100% { transform: rotate(0); }
  5% { transform: rotate(18deg); }
  10% { transform: rotate(-16deg); }
  15% { transform: rotate(12deg); }
  20% { transform: rotate(-10deg); }
  25% { transform: rotate(6deg); }
  30% { transform: rotate(-4deg); }
  35% { transform: rotate(0); }
}

@keyframes bell-glow {
  0%, 100% { box-shadow: 0 0 0 0 rgba(63, 89, 234, 0.45); }
  50% { box-shadow: 0 0 10px 3px rgba(63, 89, 234, 0.45); }
}

@keyframes badge-pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.15); }
}

@media (prefers-reduced-motion: reduce) {
  .has-unread .action-btn-circle,
  .has-unread .action-btn-circle .bi-bell,
  .has-unread .action-btn-circle .badge-dot-noti {
    animation: none;
  }
  .has-unread .action-btn-circle {
    box-shadow: 0 0 8px 2px rgba(63, 89, 234, 0.45);
  }
}

/* User profile dropdown styles */
.header-profile-img {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #e2e8f0;
}

.header-profile-name {
  font-size: 13px;
  font-weight: 600;
  color: #334155;
  margin-left: 8px;
}

.profile-btn {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.profile-btn .dropdown-arrow {
  font-size: 0.75rem;
  color: #64748b;
  margin-left: 6px;
}

/* Notification Dropdown Custom styles */
.notification-dropdown-menu {
  width: 320px;
}

.dropdown-header-custom {
  padding: 16px;
  background-color: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
  font-weight: 700;
  color: #0f172a;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.bg-purple {
  background-color: var(--primary-color) !important;
}

.dropdown-body-notifications {
  max-height: 280px;
  overflow-y: auto;
}

.dropdown-item-notification {
  display: block;
  padding: 12px 16px;
  border-bottom: 1px solid #f1f5f9;
  text-decoration: none;
  color: #334155;
  transition: background-color 0.2s ease;
  cursor: pointer;
}

.dropdown-item-notification:hover {
  background-color: #f8fafc;
}

.noti-item-title {
  font-size: 13px;
  color: #0f172a;
}

.noti-item-desc {
  font-size: 12px;
  color: #64748b;
  margin: 4px 0 0 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.noti-item-date {
  font-size: 10px;
  color: #94a3b8;
  display: block;
  margin-top: 4px;
}

.noti-item-time {
  margin-left: 8px;
}

.unread-dot {
  display: block;
  width: 8px;
  height: 8px;
  background-color: var(--primary-color);
  border-radius: 50%;
}

/* Trello-style: the unread dot is itself the "mark as read" control. */
.unread-dot-btn {
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  display: grid;
  place-items: center;
  border: 0;
  border-radius: 50%;
  background: none;
  padding: 0;
  cursor: pointer;
}

.unread-dot-btn:hover {
  background: #e8ecf8;
}

.noti-mark-all {
  border: 0;
  background: none;
  padding: 0;
  font-size: 12px;
  font-weight: 500;
  color: var(--primary-color);
  cursor: pointer;
}

.noti-mark-all:hover {
  text-decoration: underline;
}

.no-noti-placeholder {
  text-align: center;
  padding: 30px;
  color: #94a3b8;
  font-size: 13px;
}

/* Password Toggle Icon inside modal */
.password-toggle-icon-custom {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #64748b;
  z-index: 2;
}

.password-toggle-icon-custom:hover {
  color: var(--primary-color);
}

.pr-5 {
  padding-right: 38px !important;
}

.btn-primary-custom {
  background-color: var(--primary-color);
  color: #ffffff;
  border: none;
  font-weight: 600;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.btn-primary-custom:hover:not(:disabled) {
  background-color: #7c5cfc;
  color: #ffffff;
}

.btn-primary-custom:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.password-rules-checklist-custom {
  background: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  padding: 10px;
}

.rule-item-custom {
  font-size: 0.75rem;
  font-weight: 500;
}

/* Scrollbars styling */
.dropdown-body-notifications::-webkit-scrollbar,
.sidebar-nav::-webkit-scrollbar {
  width: 5px;
}

.dropdown-body-notifications::-webkit-scrollbar-thumb,
.sidebar-nav::-webkit-scrollbar-thumb {
  background-color: #cbd5e1;
  border-radius: 4px;
}

.content-footer {
  height: 50px;
  background-color: #ffffff;
  border-top: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 15px;
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 99;
  transition: left 0.3s ease;
  font-family: "Plus Jakarta Sans", sans-serif;
  font-size: 12px;
  color: #64748b;
}

@media (min-width: 992px) {
  .content-header {
    left: 70px;
  }
  .content-header.sidebar-shifted {
    left: 260px;
  }
  .content-footer {
    left: 70px;
  }
  .content-footer.sidebar-shifted {
    left: 260px;
  }
}

@media (max-width: 991px) {
  .content-header {
    left: 0 !important;
  }
  .content-footer {
    left: 0 !important;
  }
}

/* Button Hover Styles matching Apply Leave (/pmfdue) page (Bottom to Top Fill) */
.btn-primary-standard {
  background-color: var(--primary-color) !important;
  color: #ffffff !important;
  border: 1px solid var(--primary-color) !important;
  box-shadow: inset 0 0 0 0 #ffffff !important;
  transition: all 400ms ease !important;
  outline: 3px var(--primary-color) solid;
  outline-offset: -3px;
  font-weight: 600 !important;
}

.btn-primary-standard:hover:not(:disabled) {
  color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
  box-shadow: inset 0 -100px 0 0 #ffffff !important;
}

.btn-primary-standard:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  outline: none;
}

.btn-cancel-standard {
  background-color: #dc3545 !important;
  color: #ffffff !important;
  border: 1px solid #dc3545 !important;
  box-shadow: inset 0 0 0 0 #ffffff !important;
  transition: all 400ms ease !important;
  outline: 3px #dc3545 solid;
  outline-offset: -3px;
  font-weight: 600 !important;
}

.btn-cancel-standard:hover {
  color: #dc3545 !important;
  border-color: #dc3545 !important;
  box-shadow: inset 0 -100px 0 0 #ffffff !important;
}
</style>
